import { z } from 'zod';
import { ImageCornSchema, InspectionCornSchema } from '../base.js';
import { MediaMetadataSchema } from '../base/mediaMetadata.js';
export const ImageSchema = z.object({
    description: z.string().optional(),
    fileName: z.string(),
    imageId: ImageCornSchema,
    inspectionId: InspectionCornSchema,
    labels: z.array(z.string()),
    metadata: MediaMetadataSchema.default({}),
    order: z.number(),
    s3Key: z.string(),
    title: z.string(),
    uploadedDate: z.string(),
    uploadedBy: z.string(),
});
export const ImageWithSignedUrlSchema = ImageSchema.omit({ s3Key: true }).extend({
    signedUrl: z.url(),
});
